import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import TitleReveal from '@/components/base/TitleReveal';
import ExposureResolve from '@/components/base/ExposureResolve';

export default function FinalCta() {
  return (
    <section className="relative h-[560px] md:h-[720px] w-full overflow-hidden">
      <ExposureResolve className="absolute inset-0">
      <img
        src="https://public.readdy.ai/ai/img_res/sandbox/f2895d2f16dd8702941ce32547f07592/1802b3df-061e-4996-b201-639cd7eafb1d_mw-finalcta.webp"
        width={1920}
        height={1000}
        loading="lazy"
        decoding="async"
        alt="Calm modern laundry room with a white washing machine"
        title="Book an appliance repair with MENDWELL"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      </ExposureResolve>
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/15 to-transparent" />
      <Container className="relative z-10 flex h-full flex-col justify-end pb-12 md:pb-20">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-16 items-end">
          <TitleReveal className="text-[36px] md:text-[52px] lg:text-[56px] font-medium leading-[1.04] tracking-[-0.025em] text-white">
            Let&apos;s Get Your Home Running Again.
          </TitleReveal>
          <div>
            <p className="max-w-md text-[15px] md:text-base leading-relaxed text-white/85">
              Send a repair request in a few minutes. We&apos;ll review it and contact you to confirm a visit time.
            </p>
            <Link to="/book" className="mt-6 inline-flex h-12 items-center whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm text-white hover:bg-primary-600 mw-btn">
              Book a Repair
            </Link>
          </div>
        </div>
      </Container>
    </section>
  );
}